import type { IStoreState } from 'interfaces/store/store-state';

export const getSelectedOnboardingStep = (state: IStoreState) => state.features.onboarding?.selectedOnboardingStep;

export const getDisplayedOnboardingSteps = (state: IStoreState) => state.features.onboarding?.displayedSteps;

export const getIsChecklistOpen = (state: IStoreState) => state.features.onboarding?.isChecklistOpen;
